<template lang="html">
  <div id="d-page-template-1">

    
    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2 class="txt-breadcrumb">
            <span>Vacantes</span>
            {{ row.name}}
          </h2>
        </div>
      </div>
    </section>

    <section class="requests-section">
      <div class="box-results">

        <div class="card">
          <div class="tabs">
            <div class="tab-content">
              <div class="post-template-s5">
                <div class="box-main-content">
                  <div class="box-top">
                    <div class="col col-title">
                      <h5 class="title">{{ row.name}}</h5>
                    </div>

                    <div class="col col-posted">
                      <h6 class="date">Publicado {{ row.created }}</h6>
                    </div>

                    <div class="col-12 col-location">
                      <h5 class="subtitle">{{ row.state }}, {{ row.town }}.</h5>
                      <div class="box-bubbles" v-for="(dep, indd) in row.departaments" :key="'dep-'+indd">
                          <span class="bubble">{{dep.name}}</span>
                        </div>
                    </div>
                  </div>

                  <div class="box-info">
                    <h6 class="date">
                      <span class="days">{{row.schedule}}</span>
                     
                    </h6>

                    <!-- <div class="mt-3 box-long-descr">
                      <h5 class="box-title">Descripción del puesto:</h5>
                      <div class="descr">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </p>
                      </div>
                    </div> -->

                    <div class="mt-4 box-long-descr">
                      <h5 class="box-title">Requisitos:</h5>
                      <div class="descr" v-html="row.requirements">
                        
                      </div>
                    </div>
                  </div>

                  <div class="box-actions">
                    <a class="btn btn-s1 bg-red btn-apply" @click="saveAplication">Postularme</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
          <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
          <div v-html="modal.msg"></div>
          
        </sweet-modal>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },
      row:{},
      id:null,
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
    getRow(){
      axios.get(tools.url("/api/jobs/"+this.id)).then((response)=>{
          this.row = response.data;
      }).catch(()=>{});
    },
    saveAplication(){
      this.modal.icon = "";
      this.modal.msg = 'Cargando...';
      this.modal.block = true;
      this.$refs.modal.open();
      axios.get(tools.url("/api/saveAplication/"+this.id)).then((response)=>{
          this.modal.block = false;
          this.modal.icon = 'success';
          this.modal.msg = 'Información guardada correctamente';
         
      }).catch((error)=>{
          this.modal.block = false;
          this.modal.icon = 'error';
          this.modal.msg = error.response.data.msg;
      });
      
    }
  },
  mounted(){
    this.id=this.$route.params.id;
      this.getRow();
  }
}
</script>